import React, { useState, useEffect } from 'react';
import {Container, Nav, Navbar, NavDropdown} from "react-bootstrap";
import logo from '../../Assets/dcm_new_logo.png';
import './NavBar.css';
import i18next from 'i18next';
import { useTranslation } from "react-i18next";
import getLanguage from '../Translation/Translation';
import DemoModal from '../DemoModal/DemoModal';

export const languages = [
  {
    code: 'en',
    name: 'English'
  },
  {
    code: 'th',
    name: 'Thai'
  }
];

function onLanguageClick(code){
  i18next.changeLanguage(code);

  // localStorage.setItem("language", code ? 'th' : 'en')
}

function NavBarComponent() {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [isSticky, setIsSticky] = useState(true);

  // ตรวจจับ scroll เพื่อเพิ่ม shadow
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 0);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // ตรวจจับขนาดหน้าจอ
  useEffect(() => {
    const handleResize = () => {
      // ถ้าหน้าจอกว้างกว่า xl (1200px) -> ไม่ sticky
      setIsSticky(window.innerWidth < 1200);
    };

    handleResize(); // เรียกครั้งแรก
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
        return (
          <Navbar 
            collapseOnSelect  
            expand="xl" 
            sticky={isSticky ? undefined : 'top' }
            className={`custom-navbar ${scrolled ? 'scrolled' : ''}`}
          >
          <Container className="mgtop20">
            <Navbar.Brand href="/">
              <img className="dcm-logo" src={logo} alt="Logo" />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" style={{marginTop: "-20px"}}/>
            <Navbar.Collapse id="responsive-navbar-nav" className="mgleft" style={{marginTop: "-20px", }}>
              <Nav className="me-auto">
                <Nav.Link href="/about-dcm">{t('About DCM')}</Nav.Link>
                <Nav.Link href="/services">{t('Services')}</Nav.Link>
                <Nav.Link href="/products">{t('Products')}</Nav.Link>
                {/* <Nav.Link href="#EBook">{t('E-Book')}</Nav.Link> */}
                <Nav.Link href="/taxation-calendar">{t('Taxation Calendar')}</Nav.Link>
                <Nav.Link href="/contact-us">{t('Contact Us')}</Nav.Link>
              </Nav>
              <Nav className="right-nav">
                <Nav.Link className="demo-link">
                  <DemoModal />
                </Nav.Link>
                <NavDropdown title={t(getLanguage(i18next.language), {})} id="collasible-nav-dropdown">
                  {languages.map(({code,name}) => (
                    <NavDropdown.Item key={code} onClick={() => onLanguageClick(code)}>
                      {t(name)}
                    </NavDropdown.Item>
                    )
                  )}
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        );
};

export default NavBarComponent;